import { render, staticRenderFns } from "./ManageFoodType.vue?vue&type=template&id=761bf006&scoped=true"
import script from "./ManageFoodType.vue?vue&type=script&lang=js"
export * from "./ManageFoodType.vue?vue&type=script&lang=js"
import style0 from "./ManageFoodType.vue?vue&type=style&index=0&id=761bf006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761bf006",
  null
  
)

export default component.exports